module.exports = __webpack_public_path__ + "static/media/print-summary.146f9250.svg";